<div class="container main-font">
  <div class="w-100 mb-2">
    <div class="section-title">
      <div class="d-flex justify-content-between w-100">
        <div
          (click)="editWidgetReview()"
          onkeydown=""
          class="ms-4 me-2"
          nz-tooltip
          [nzTooltipTitle]="!isEdit ? 'Modifica Widget' : 'Salva Widget'"
          nzTooltipPlacement="bottom">
          <div
            class="d-flex justify-content-center align-items-center w-100 h-100"
            *ngIf="isButtonVisible()">
            <mat-icon
              class="widget-icon mb-1"
              [innerText]="isEdit ? 'done' : 'edit'"></mat-icon>
          </div>
        </div>

        <div
          *ngIf="isEdit"
          class="d-flex align-items-center justify-content-sm-center justify-content-lg-start h-100">
          <nz-col [nzXs]="24" [nzMd]="20" [nzLg]="20">
            <a
              *ngIf="checkWidgetVisible().length > 0"
              nz-dropdown
              nzTrigger="click"
              [nzDropdownMenu]="widgetMenu"
              class="mb-3 mb-md-0 w-75 text-black p-2 dropdown-link">
              Seleziona widget nascosti
              <span nz-icon nzType="down"></span>
            </a>
            <nz-dropdown-menu #widgetMenu="nzDropdownMenu">
              <ul nz-menu>
                <li
                  onkeydown=""
                  nz-menu-item
                  *ngFor="let component of checkWidgetVisible()"
                  (click)="widget(component)">
                  {{ component.alias }}
                </li>
              </ul>
            </nz-dropdown-menu>
          </nz-col>
        </div>

        <div class="d-flex justify-content-end" *ngIf="canViewSelect">
          <app-user-select
            class="w-100"
            [hidden]="true"
            [role]="userLoggedRoleName"
            (chosenUser)="getUserSelect($event)"
            [isEditMode]="isEdit"></app-user-select>
        </div>
      </div>
    </div>

    <div class="py-3" *ngIf="historicalReviewList.length > 1">
      <nz-row nzJustify="end" nzAlign="middle" class="w-100 ps-5">
        <nz-col [nzXs]="24" [nzMd]="20" [nzLg]="7">
          <nz-select
            class="mb-3 mb-md-0 w-100 me-2"
            [(ngModel)]="selectedReviewId"
            [nzPlaceHolder]="'Seleziona review'"
            (ngModelChange)="changeReviewHistorical($event)">
            <nz-option
              *ngFor="let component of historicalReviewList"
              [nzValue]="component.id"
              [nzLabel]="
                (component.review_completed_at | date: 'dd/MM/yyyy') +
                (component.in_progress ? ' In corso' : '')
              "></nz-option>
          </nz-select>
        </nz-col>
        <div *ngIf="chosenUser">
          <nz-col [nzXs]="8" [nzMd]="6" [nzLg]="2">
            <button
              class="ms-2 report-button"
              nz-button
              (click)="openReportModal()">
              Report
            </button>
          </nz-col>
        </div>
      </nz-row>
    </div>

    <div
      cdkDropList
      [cdkDropListData]="components"
      (cdkDropListDropped)="onDrop($event)"
      [cdkDropListDisabled]="!isEdit"
      class="drop-list">
      <nz-row>
        <div
          class="centered-container w-100"
          *ngIf="isAdmin && !this.chosenUser">
          <h4 class="mt-2">
            {{ 'Selezionare un utente da visionare' }}
          </h4>
        </div>
      </nz-row>

      <nz-row [hidden]="!isAdmin && !chosenUser">
        <ng-container
          *ngFor="
            let item of visibleComponents;
            let i = index;
            trackBy: trackByComponentId
          ">
          <nz-col [nzSpan]="item.size_column">
            <div
              cdkDrag
              [cdkDragDisabled]="item.id === 1"
              class="drag-item"
              [ngClass]="{ disabled: !isEdit, default: i === 0 && isEdit }">
              <div class="widget-container">
                <ng-container [ngSwitch]="item.alias">
                  <ng-container *ngSwitchCase="'Dettagli utente'">
                    <app-profile-widget
                      [isVisible]="
                        !!(
                          chosenUser &&
                          (chosenUser != this.userLogged.id || !isAdmin)
                        )
                      "
                      [chosenUser]="chosenUser"
                      [selectedReviewId]="selectedReviewId"
                      (hasLastReview)="
                        handleLastReview($event)
                      "></app-profile-widget>
                  </ng-container>

                  <ng-container *ngSwitchCase="'Gamification'">
                    <app-gamification-widget></app-gamification-widget>
                  </ng-container>

                  <ng-container *ngSwitchCase="'Monitoraggio'">
                    <app-monitoring-widget
                      [isEdit]="isEdit"
                      [isVisible]="
                        !!(
                          chosenUser &&
                          (chosenUser != this.userLogged.id || !isAdmin)
                        )
                      "
                      [chosenUser]="chosenUser"></app-monitoring-widget>
                  </ng-container>

                  <ng-container
                    *ngSwitchCase="'Monitoraggio Delta Incrementale'">
                    <app-monitoring-incremental-delta
                      [isEdit]="isEdit"
                      [isVisible]="
                        !!(
                          chosenUser &&
                          (chosenUser != this.userLogged.id || !isAdmin)
                        )
                      "
                      [selectedReviewId]="selectedReviewId"
                      [chosenUser]="
                        chosenUser
                      "></app-monitoring-incremental-delta>
                  </ng-container>

                  <ng-container *ngSwitchCase="'Riflessioni'">
                    <app-reflection-widget
                      [isEdit]="isEdit"
                      [isVisible]="
                        !!(
                          chosenUser &&
                          (chosenUser != this.userLogged.id || !isAdmin)
                        )
                      "
                      [chosenUser]="chosenUser"
                      [selectedReviewId]="
                        selectedReviewId
                      "></app-reflection-widget>
                  </ng-container>

                  <ng-container *ngSwitchCase="'Sbi'">
                    <app-sbi-widget
                      [isEdit]="isEdit"
                      [isVisible]="
                        !!(
                          chosenUser &&
                          (chosenUser != this.userLogged.id || !isAdmin)
                        )
                      "
                      [chosenUser]="chosenUser"
                      [selectedReviewId]="selectedReviewId"></app-sbi-widget>
                  </ng-container>

                  <ng-container *ngSwitchCase="'Feedback360'">
                    <app-fb360-widget
                      class="w-100"
                      [isEdit]="isEdit"
                      [chosenUser]="chosenUser"
                      [selectedReviewId]="selectedReviewId"></app-fb360-widget>
                  </ng-container>

                  <ng-container *ngSwitchCase="'Andamento ragazzi'">
                    <app-users-performance
                      [isEdit]="isEdit"
                      [isVisible]="
                        !!(
                          chosenUser &&
                          (chosenUser != this.userLogged.id || !isAdmin)
                        )
                      "
                      [chosenUser]="chosenUser"
                      [selectedReviewId]="
                        selectedReviewId
                      "></app-users-performance>
                  </ng-container>

                  <ng-container *ngSwitchCase="'Cosa pensiamo di te'">
                    <app-how-is-going
                      [isEdit]="isEdit"
                      [isVisible]="
                        !!(
                          chosenUser &&
                          (chosenUser != this.userLogged.id || !isAdmin)
                        )
                      "
                      [chosenUser]="chosenUser"
                      (isCompleteChange)="
                        onIsCompleteChange($event)
                      "></app-how-is-going>
                  </ng-container>
                </ng-container>

                <button
                  *ngIf="isEdit"
                  class="btn mt-2"
                  (click)="toggleVisibility(i)"
                  nz-tooltip
                  nzTooltipTitle="Elimina widget"
                  nzTooltipPlacement="top">
                  <img
                    [ngStyle]="{ display: item.id !== 1 ? 'block' : 'none' }"
                    src="assets/images/Shared/close.png"
                    alt="Elimina"
                    class="widget-icon" />
                </button>
              </div>
            </div>
          </nz-col>
        </ng-container>
      </nz-row>
    </div>
    <div
      class="d-flex justify-content-end"
      *ngIf="chosenUser && chosenUser != this.userLogged.id && canBeConcluded">
      <button
        nz-button
        [ngClass]="
          !isComplete ? 'disabled-btn' : 'secondary-btn cursor-pointer'
        "
        [disabled]="!isComplete"
        (click)="saveReview()">
        Concludi Review
      </button>
    </div>
  </div>
</div>

<ng-template #reportModal let-modal>
  <pre class="report-view">{{ formattedText }}</pre>
  <div class="d-flex justify-content-end">
    <button nz-button class="copy-button" (click)="copyFormattedText()">
      Copia
    </button>
  </div>
</ng-template>
